/**
 * Flashes a "⚡ TIER N" banner whenever the enemy tier increases (every 30 s).
 * Fades in fast (15 %), holds, then fades out (last 35 %).
 */
export function TierAnnouncement({ announcement }) {
  if (!announcement) return null;

  const DURATION = 2500;
  const elapsed  = performance.now() - announcement.startTime;
  if (elapsed > DURATION) return null;

  const progress = elapsed / DURATION;
  const opacity  =
    progress < 0.15 ? progress / 0.15 :
    progress > 0.65 ? 1 - (progress - 0.65) / 0.35 :
    1;

  return (
    <div className="tier-announcement" style={{ opacity }}>
      <span className="tier-announcement-text">⚡ TIER {announcement.tier + 1}</span>
    </div>
  );
}
